// extracted by mini-css-extract-plugin
export default {"button-to-top":"BackToTopButton_button-to-top__0IVat","movebtn":"BackToTopButton_movebtn__boSUa","icon":"BackToTopButton_icon__+zkxD"};